import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import * as Sentry from '@sentry/browser';

import App from './App';
import 'typeface-roboto';
import './assets/styles/styles.scss';
import {unregister} from './registerServiceWorker';
import initialState from './store/initialState';
import configureStore from './store/configureStore';

if (process.env.REACT_APP_ENV !== 'development') {
    Sentry.init({
        dsn: "https://c5ef81220eba4f05bbd40315353a1ec8@sentry.io/1324584",
        attachStacktrace: true
    });
}

const store = configureStore(initialState);

ReactDOM.render(
    <Provider store={store}>
        <Router>
            <Route component={App} />
        </Router>
    </Provider>,
    document.getElementById('root'));
unregister();


// WEBPACK FOOTER //
// ./src/index.js